import { z } from "zod";

export type MerchantEditorFormValues = {
  business_name: string;
  short_intro: string;
  description: string;
  business_url: string;
  business_category_id: string;
  partner_type: string;
  phone: string;
};

export const createDefaultMerchantEditorValues = (): MerchantEditorFormValues => ({
  business_name: "",
  short_intro: "",
  description: "",
  business_url: "",
  business_category_id: "",
  partner_type: "",
  phone: "",
});

const optionalUrlSchema = z
  .string()
  .trim()
  .max(500, "URL must be 500 characters or fewer")
  .refine((value) => value === "" || /^https?:\/\/.+/.test(value), {
    message: "URL must start with http:// or https://",
  });

export const updateMerchantEditorSchema: z.ZodType<MerchantEditorFormValues> = z.object({
  business_name: z
    .string()
    .trim()
    .min(1, "Please enter business name")
    .max(200, "Business name must be 200 characters or fewer"),
  short_intro: z.string().trim().max(300, "Short intro must be 300 characters or fewer"),
  description: z.string().trim().max(2000, "Description must be 2000 characters or fewer"),
  business_url: optionalUrlSchema,
  business_category_id: z.string().trim(),
  partner_type: z.string().trim(),
  phone: z.string().trim().max(30, "Phone must be 30 characters or fewer"),
});

export type SuspendMerchantFormValues = {
  reason: string;
};

export const suspendMerchantSchema: z.ZodType<SuspendMerchantFormValues> = z.object({
  reason: z
    .string()
    .trim()
    .min(1, "Please enter a reason")
    .max(1000, "Reason must be 1000 characters or fewer"),
});
